import { IsDateString, IsNumber, IsOptional, IsString } from 'class-validator';

export class DealSongsSummaryDto {
    @IsNumber()
    dealSongLinkFlag!: number;
    @IsNumber()
    projectId!: number;
    @IsString()
    assetCode!: string;
    @IsOptional()
    @IsString()
    songArtist!: string;
    @IsOptional()
    @IsString()
    songArtistImage!: string;
    @IsOptional()
    @IsString()
    songName!: string;
    @IsOptional()
    @IsNumber()
    writingShare!: number;
    @IsDateString()
    @IsOptional()
    releaseDate!: string;
    @IsOptional()
    @IsString()
    label!: string;
    @IsOptional()
    @IsString()
    showSongStatus!: string;
    @IsOptional()
    @IsString()
    showSongDealStatus!: string;
    @IsOptional()
    @IsNumber()
    gSongEntryId!: number;
    @IsOptional()
    @IsNumber()
    step!: number;
    @IsOptional()
    @IsNumber()
    totalRows!: number;
}

export class AssetLinkDto {
    @IsOptional()
    @IsString()
    assetcode!: string;
    @IsOptional()
    @IsString()
    projectid!: string;
    @IsOptional()
    @IsString()
    songref!: string;
}
